import { MetadataItem } from '@gelato-api-ui/core/metadata/types/metadata-item';

const getMetadataItem = (items: MetadataItem[], key: string, skipEmptyValues?: boolean): MetadataItem =>
  (items || []).find((loopMetadataItem: MetadataItem): boolean => {
    if (loopMetadataItem.key !== key) {
      return false;
    }

    if (skipEmptyValues && !loopMetadataItem.value) {
      return false;
    }

    return true;
  });

/**
 * @deprecated
 * please use getItemValue method of MetadataService instead
 */
export const getMetadataItemValue = (
  items: MetadataItem[],
  key: string,
  skipEmptyValues?: boolean,
): string | string[] => {
  const item: MetadataItem = getMetadataItem(items, key, skipEmptyValues);

  return item ? item.value : null;
};
